import { render, staticRenderFns } from "./CommodityOverflow.vue?vue&type=template&id=2382f812&scoped=true"
import script from "./CommodityOverflow.vue?vue&type=script&lang=js"
export * from "./CommodityOverflow.vue?vue&type=script&lang=js"
import style0 from "./CommodityOverflow.vue?vue&type=style&index=0&id=2382f812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382f812",
  null
  
)

export default component.exports